import React from 'react'
import {get} from "../tools/restful"
import { BrowserRouter as Router, Route, Switch } from "react-router-dom"
import { Link, NavLink as RouterNavLink } from "react-router-dom";
import {Container, Col, Row, Button} from 'reactstrap'
import MenuIdPage from './MenuIdPage'
import Menu from './MenuComponents/Menu'


class UntappdDataLayer extends React.Component {
    constructor(props){
        super(props)
        this.state = {
            tapsMenu: [],
            bottlesMenu: '',
            wineMenu: '',
            date: ''
        }
        this._style = {
            backgroundImage: `url(https://pizza-luce-styles.s3.us-east-2.amazonaws.com/img/background_300.png)`
        }
    }
    componentDidMount(){
        let tapsId = this.props.match.params.tapsId
        let bottlesId = this.props.match.params.bottlesId
        let wineId = this.props.match.params.wineId

        let url = `https://beta.pizzaluce.com/api/untappd/${tapsId}/${bottlesId}/${wineId}`

        fetch(url)
        .then(res => {
            console.log(res)
            return res.json()
        })
        .then(data => this.setState({
            tapsMenu: data.tapsMenu.menu,
            bottlesMenu: data.bottlesCans.menu,
            wineMenu: data.wineMenu.custom_menu,
            date: data.date
        })
        ).catch(err => (
            console.log(err)
        ))
    }
    render(){
        console.log(this.state)
        return (
        <div>
            
            <Container className="taps page">
            
                <div style={{backgroundImage: `url(https://pizza-luce-styles.s3.us-east-2.amazonaws.com/img/background_300.png)`}} className="background left">
                    <div className="menu-header">
                        <img className="logo" src='https://pizza-luce-styles.s3.us-east-2.amazonaws.com/img/pink_square_logo.png'/>
                        <img className="taps-header" src="https://pizza-luce-styles.s3.us-east-2.amazonaws.com/img/TAPS-pink.png"/>
                    </div>
                    <div className="date-time">
                        Our current taps as of {this.state.date}
                    </div>
                    
                    
                    <div>
                       {this.state.tapsMenu.sections 
                            ? this.state.tapsMenu.sections.map(section => (
                                <div className="section">

                               
                                <div className="header-title">{section.name}</div>
                                    <div>
                                        {section.items 
                                            ? section.items.map(item => (
                                                <div className="beer-title">
                                                    <span>{item.name}</span>
                                                    <span> ({item.original_brewery.replace("Company", '').replace("Cooperative", '').replace("Brewing", '').replace("Brewery", '')})</span>
                                                    <span> {item.style}</span> | 
                                                    <span> {item.abv}% </span>
                                                    <span>{item.containers[0].container_size.name.split(' ',1)}</span>
                                                </div>
                                            ))
                                            :   <span>loading...</span>
                                        }
                                    </div>
                                </div>
                            ))
                            : <span>loading...</span>
                       }
                    </div>
                </div>
                <div style={{backgroundImage: `url(https://pizza-luce-styles.s3.us-east-2.amazonaws.com/img/background_300.png)`}} className="background left">
                    <div className="menu-header">
                        <img className="logo" src='https://pizza-luce-styles.s3.us-east-2.amazonaws.com/img/pink_square_logo.png'/>
                        <img className="taps-header" src="https://pizza-luce-styles.s3.us-east-2.amazonaws.com/img/TAPS-pink.png"/>
                    </div>
                    <div className="date-time">
                        Our current taps as of {this.state.date}
                    </div>
                    <div>
                    {this.state.tapsMenu.sections 
                            ? this.state.tapsMenu.sections.map(section => (
                                <div className="section">

                               
                                <div className="header-title">{section.name}</div>
                                    <div>
                                        {section.items 
                                            ? section.items.map(item => (
                                                <div className="beer-title">
                                                    <span>{item.name}</span>
                                                    <span> ({item.original_brewery.replace("Company", '').replace("Cooperative", '').replace("Brewing", '').replace("Brewery", '')})</span>
                                                    <span> {item.style}</span> | 
                                                    <span> {item.abv}% </span>
                                                    <span>{item.containers[0].container_size.name.split(' ',1)}</span>
                                                </div>
                                            ))
                                            :   <span>loading...</span>
                                        }
                                    </div>
                                </div>
                            ))
                            : <span>loading...</span>
                       }
                    </div>
                </div>
            </Container>
            <Container className="bottles-cans page">
                <Menu 
                    menuName='bottles-cans' 
                    menuData={this.state.bottlesMenu}
                    menuImage={`https://pizza-luce-styles.s3.us-east-2.amazonaws.com/img/BC-pink.png`}
                />
                
            </Container>
            <Container className="red-wine page">
                <Menu 
                    menuName="red-wine" 
                    menuData={this.state.wineMenu.custom_sections ? this.state.wineMenu.custom_sections[1] : ''}
                    menuImage={`https://pizza-luce-styles.s3.us-east-2.amazonaws.com/img/red_wine.png`}
                />
            </Container>
            <Container className="white-wine page">
                <Menu 
                    menuName="white-wine" 
                    menuData={this.state.wineMenu.custom_sections ? this.state.wineMenu.custom_sections[0] : ''}
                    menuImage={`https://pizza-luce-styles.s3.us-east-2.amazonaws.com/img/white_wine.png`}
                />
            </Container>              
        </div>    
            
           
            
            
          
           
            
        )
    }
}
export default UntappdDataLayer